import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, CircleAlert } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | error
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(r.data.payment_status) || attempts.current >= 10) { setStatus("error"); return; }
      } catch { if (attempts.current >= 10) { setStatus("error"); return; } }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="text-center fade-up" data-testid="payment-success-screen">
        {status === "checking" && (
          <>
            <div className="w-10 h-10 mx-auto mb-6 rounded-full border-4 border-zinc-200 border-t-[#FF4F00] animate-spin" />
            <h1 className="font-heading font-extrabold text-2xl tracking-tight">Confirmando seu pagamento...</h1>
            <p className="text-zinc-500 text-sm mt-3">Isso leva só alguns segundos.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-[#FF4F00] mx-auto mb-6" />
            <h1 className="font-heading font-extrabold text-3xl tracking-tight" data-testid="payment-paid-title">Bem-vindo ao Pro!</h1>
            <p className="text-zinc-600 mt-4 max-w-sm mx-auto">Seu plano foi ativado. Depoimentos ilimitados liberados.</p>
            <Link data-testid="payment-success-dashboard-btn" to="/dashboard" className="inline-block mt-8 px-8 py-3.5 bg-[#0A0A0A] text-white rounded-full font-semibold text-sm hover:bg-zinc-800 transition-colors">
              Ir para o painel
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <CircleAlert size={56} className="text-red-500 mx-auto mb-6" />
            <h1 className="font-heading font-extrabold text-2xl tracking-tight">Não conseguimos confirmar o pagamento</h1>
            <p className="text-zinc-500 text-sm mt-3 max-w-sm mx-auto">Se o valor foi cobrado, seu plano será ativado em instantes. Caso contrário, tente novamente.</p>
            <Link data-testid="payment-error-pricing-btn" to="/pricing" className="inline-block mt-8 px-8 py-3.5 border border-zinc-300 rounded-full font-semibold text-sm text-zinc-800 hover:border-zinc-500 transition-colors">
              Voltar aos preços
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
